module.exports = __webpack_public_path__ + "img/10ab643.png";